import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, {
    locale: 'pt_BR',
    events: 'blur',
    validity: false
})


// WEBPACK FOOTER //
// ./src/shared/helpers/vee-validate.js